import * as React from 'react';
import AssetsManager from '../../../../../../common/utils/AssetsManager';
import {COMMON} from '../../../../../../common/constants/LabelConstants';
import {LOAN_APPLICATION_MX} from '../../../../../constants/LabelConstants';
import {INPUTS} from '../../../../../constants/MX/AdminInputs';
import InputText from '../../../../../../common/components/InputText';
import Button from '../../../../../../common/components/Button';

class ValidationIdCurpView extends React.Component
    <{data: {token: string}, onPressOk: any},
    {curp: string, curpError: string, showErrors: boolean}> {
    constructor(props) {
        super(props);
        this.state = {
            curp: '',
            curpError: null,
            showErrors: false,
        };
    }

    onChangeCurp = (value, error) => {
        this.setState({
            curp: value,
            curpError: error,
        });
    }

    onPressNext = () => {
        if (this.state.curpError != null) {
            this.setState({showErrors: true});
        } else {
            this.props.onPressOk(this.state.curp, this.props.data.token);
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container text-center">
                            <img
                                className="py-3"
                                src={AssetsManager('/assets/images/common/thin-attention-error.svg')}/>
                            <h5 className="main-title pt-3">{COMMON.ERROR_TITLE}</h5>
                            <p>
                                El Curp leido de la imágen no pudo ser validado, favor de rectificar para
                                reprocesar la validación de identificación.
                            </p>
                        </div>
                        <InputText label={LOAN_APPLICATION_MX.CURP}
                                   id={INPUTS.CURP}
                                   value={this.state.curp}
                                   required={true}
                                   hasError={this.state.showErrors}
                                   labelError={this.state.curpError}
                                   onChange={this.onChangeCurp}/>
                        <div className="container text-center">
                            <Button text={LOAN_APPLICATION_MX.NEXT}
                                    onPress={this.onPressNext} role="button"
                                    customClass="px-md-5 btn-block"/>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ValidationIdCurpView;
